export const GET_TOUR = 'GET_TOUR'
export const GET_TOUR_SUCCESS = 'GET_TOUR_SUCCESS'
export const GET_TOUR_FAILURE = 'GET_TOUR_FAILURE'

export const GET_RANKING = 'GET_RANKING'
export const GET_RANKING_SUCCESS = 'GET_RANKING_SUCCESS'
export const GET_RANKING_FAILURE = 'GET_RANKING_FAILURE'
